// extracted by mini-css-extract-plugin
module.exports = {"tab_container":"shopcategories_tab_container__13Sqg","skelton":"shopcategories_skelton__5nabt"};